{
    "form_title": "Neue Kontaktperson",
    "form_sub_title": "Diese wird in der Warenwirtschaft gespeichert und ist für alle sichtbar",

    "form_label__title": "Anrede",
    "form_label__first_name": "Vorname",
    "form_label__last_name": "Familienname",
    "form_label__email": "E-Mail",
    "form_label__phone": "Telefon",
    "form_label__mobile": "Mobil",
    "form_label__fax": "Fax",

    "form_placeholder__title": "Herr",
    "form_placeholder__first_name": "Max",
    "form_placeholder__last_name": "Mustermann",
    "form_placeholder__email": "m.mustermann@email.com",
    "form_placeholder__phone": "0123 12312341",
    "form_placeholder__mobile": "0123 12312341",
    "form_placeholder__fax": "0123 12312341"
}
